module.exports = __webpack_public_path__ + "static/assets/ac7cf070141b298672808b0e3bde816b.svg";